import React, { FC }  from 'react'
import styles from './index.module.less'

const PageBox:FC<{ children: any; }> = (props) => (
  <div className={styles.container}>

    <div className={styles.formWrapper}>
      {props.children}
    </div>
  </div>
)

export default PageBox